import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Route handler for /download/mobile-app
 * This component redirects to the Google Play Store
 */
const MobileAppDownloadRoute: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to Google Play Store
    window.location.href = 'https://play.google.com/store/apps/details?id=com.complin&pcampaignid=web_share';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-gray-600 mb-4">Preparing download...</p>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
      </div>
    </div>
  );
};

export default MobileAppDownloadRoute;

